export default __webpack_public_path__ + "static/media/ev.e3f5ebd9.svg";